import { IMaskInput } from 'react-imask';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';
import { forwardRef } from 'react';

const TextMaskCustom = forwardRef(function TextMaskCustom(props, ref) {
    const { onChange, mask, ...other } = props;
    return (
        <IMaskInput
            {...other}
            mask={mask}
            definitions={{
                '#': /[0-9]/,
                '+': '+',
                ' ': ' ',
            }}
            inputRef={ref}
            onAccept={(value) => onChange({ target: { name: props.name, value } })}
            overwrite
        />
    );
});

TextMaskCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    mask: PropTypes.string.isRequired,
};

export function AvlMaskedInput({ label = '', value, onChange, isDisabled, error, helperText, mask, ...props }) {
    const sx = !isDisabled
        ? {
            '.MuiInput-root': {
                '&::before': {
                    borderBottom: error ? '1px solid #d32f2f' : '1px solid rgba(0, 0, 0, 0.42)',
                },
                '&:hover:not(.Mui-disabled):before': {
                    borderBottom: error ? '2px solid #d32f2f' : '2px solid rgba(0, 0, 0, 0.87)',
                },
                '&::after': {
                    borderBottom: error ? '2px solid #d32f2f' : '2px solid #1976d2',
                },
            },
            '.MuiInput-root.Mui-disabled': {
                borderRadius: '4px',
                backgroundColor: '#00000007',
                '&::before': {
                    borderBottomColor: 'transparent',
                },
            },
            '.MuiFormLabel-root': {
                color: error ? '#d32f2f' : 'rgba(0, 0, 0, 0.6)',
                '&.Mui-focused': {
                    color: error ? '#d32f2f' : '#1976d2',
                },
            },
            '.MuiFormLabel-root.Mui-disabled': {
                color: 'rgba(0, 0, 0, 0.6)',
            },
            '.MuiInput-input': {
                color: 'rgba(0, 0, 0, 0.87)',
                '&::placeholder': {
                    color: 'rgba(0, 0, 0, 0.42)',
                    opacity: 1,
                },
            },
            '.MuiInput-input.Mui-disabled': {
                WebkitTextFillColor: 'black',
            },
            '.MuiFormHelperText-root': {
                margin: '3px 14px 0',
                color: error ? '#d32f2f' : 'rgba(0, 0, 0, 0.6)',
            },
        }
        : undefined;

    return (
        <TextField
            fullWidth
            label={label}
            value={value}
            onChange={onChange}
            disabled={isDisabled}
            error={error}
            helperText={helperText}
            InputProps={{
                inputComponent: TextMaskCustom,
                inputProps: {
                    mask: mask,
                    name: props.name,
                },
            }}
            variant={props.variant || 'standard'}
            required={props.required}
            className={props.className}
            sx={props.sx || sx}
            {...props}
        />
    );
}

AvlMaskedInput.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    isDisabled: PropTypes.bool,
    error: PropTypes.bool,
    helperText: PropTypes.string,
    mask: PropTypes.string.isRequired,
    className: PropTypes.string,
    required: PropTypes.bool,
    variant: PropTypes.string,
    name: PropTypes.string,
}; 
